<!--
 * @Author: Tang Hao
 * @Date: 2024-07-05 15:05:48
 * @LastEditors: Tang Hao
 * @LastEditTime: 2025-12-29 15:07:41
 * @Description:
-->
<template>
  <div class="edit-table">
    <slot name="toolbar"></slot>
    <el-form>
      <vxe-table  ref="fineTable" :data="paymentList">
        <vxe-table-column min-width="100" field="id" title="明细编码"></vxe-table-column>
        <vxe-table-column min-width="100" field="poolAccountCode" title="红包池编码"></vxe-table-column>
        <vxe-table-column min-width="100" field="poolAccountName" title="红包池名称"></vxe-table-column>
        <vxe-table-column min-width="100" field="sourceTypeName" title="关联客户名称"></vxe-table-column>
        <vxe-table-column min-width="100" field="sourceType" title="客户编码"></vxe-table-column>
        <!-- <vxe-table-column min-width="100" field="changeType" title="收支类型" >
            <template #default="{ row }">
                <span v-if="row.changeType==='1'">收入</span>
                <span v-if="row.changeType==='0'">支出</span>
            </template>
        </vxe-table-column> -->
        <vxe-table-column min-width="130" field="amount" title="红包提现金额（元）"></vxe-table-column>
        <vxe-table-column min-width="120" field="basicChargeAmount" title="基础服务费（元）"></vxe-table-column>
        <vxe-table-column min-width="120" field="upChargeAmount" title="上浮服务费（元）"></vxe-table-column>
        <vxe-table-column min-width="140" field="poolDeductionAmount" title="红包池扣减金额（元）"></vxe-table-column>
        <vxe-table-column min-width="130" field="createTime" title="创建时间"></vxe-table-column>
      </vxe-table>
    </el-form>
    <div class="pagination">
      <el-pagination background layout="total,prev, pager, next" @current-change="handleCurrentChange" :current-page="pagination.current" :page-size="pagination.pageSize" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import elementComponents from './elementComponents';

export default {
  name: 'Payment',
  props: {
    value: Object,
  },
  components: {
    ...elementComponents,
  },
  watch: {
    value() {
      this.paymentList = this.value.data;
      this.pagination.total = this.value.count;
    },
  },
  data() {
    return {
      paymentList: [], // 支付明细
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
      },
    };
  },

  methods: {
    // change分页
    handleCurrentChange(val) {
      console.log(val);
      this.pagination.current = val;
    },

  },
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;

}
.form-conrtol {
  width: 100%;
}
/deep/ .vxe-body--column {
  height: 50px !important;
}
.pagination{
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  color: white !important;
}
</style>
